/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.3 routes of CodeOcean::Application.
 * @version 66d385dc277554d4246ae1e49f38d395e1aef86ce88c90520b4ead6d07052033
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "/",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /internal_users/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard/dump_docker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_dump_docker_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dump_docker"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dashboard/dump_docker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_dump_docker_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dump_docker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/internal/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /error_templates/:id/attribute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attribute_error_template_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /error_templates/:id/attribute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attribute_error_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_templates/by_file_type/:file_type_id(.:format)
 * @param {any} file_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_file_type_file_templates_url = /*#__PURE__*/ __jsr.r({"file_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[6,"by_file_type"],[2,[7,"/"],[2,[3,"file_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /file_templates/by_file_type/:file_type_id(.:format)
 * @param {any} file_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_file_type_file_templates_path = /*#__PURE__*/ __jsr.r({"file_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[6,"by_file_type"],[2,[7,"/"],[2,[3,"file_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:id/change_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_password_internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:id/change_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_password_internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/:id/clear_question(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_question_request_for_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_question"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/:id/clear_question(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_question_request_for_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_question"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_proxy_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_proxy_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /code_ocean/files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_ocean_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_ocean"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /code_ocean/files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_ocean_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_ocean"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /code_ocean/files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_ocean_files_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_ocean"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /code_ocean/files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_ocean_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_ocean"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /comment_by_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_by_id_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comment_by_id"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /comment_by_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comment_by_id_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comment_by_id"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /community_solutions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_solution_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /community_solutions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_solution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /community_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_solutions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /community_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_solutions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /consumers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumer_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /consumers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /consumers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /consumers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/download/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_from_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/download/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_from_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/download/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/download/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/download_proforma(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_proforma_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_proforma"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/download_proforma(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_proforma_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_proforma"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/download_stream/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_stream_file_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_stream"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/download_stream/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_stream_file_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_stream"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /community_solutions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_community_solution_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /community_solutions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_community_solution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community_solutions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /consumers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_consumer_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /consumers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_consumer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /error_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_error_template_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /error_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_error_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /error_template_attributes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_error_template_attribute_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /error_template_attributes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_error_template_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercise_collections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_collection_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercise_collections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_collection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/:id/edit(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_programming_group_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/:id/edit(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_programming_group_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/:id/edit(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_user_exercise_feedback_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/:id/edit(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exercise_user_exercise_feedback_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/:id/edit(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/:id/edit(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/:id/edit(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/:id/edit(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /file_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_file_template_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /file_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_file_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_file_type_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /file_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_file_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/:id/edit(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/:id/edit(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/:id/edit(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/:id/edit(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_internal_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_group_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_proxy_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_proxy_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_study_group_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /study_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_study_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tag_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tips/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tip_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /tips/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /error_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /error_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /error_template_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_attribute_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /error_template_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /error_template_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_attributes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /error_template_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_template_attributes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /error_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_templates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /error_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const error_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/shell(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_command_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shell"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/shell(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_command_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shell"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execution_environments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /execution_environments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execution_environments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercise_collections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_collection_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercise_collections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_collection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercise_collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_collections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /exercise_collections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_collections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/:id(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_programming_group_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/:id(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_programming_group_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_programming_groups_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_programming_groups_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/request_for_comments(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_request_for_comments_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/request_for_comments(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_request_for_comments_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/:id(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_user_exercise_feedback_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/:id(.:format)
 * @param {any} exercise_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_user_exercise_feedback_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_user_exercise_feedbacks_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercise_user_exercise_feedbacks_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercises_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /exercises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exercises_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/export_external_check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_external_check_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_external_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/export_external_check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_external_check_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_external_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/export_external_confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_external_confirm_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_external_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/export_external_confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_external_confirm_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_external_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/:id(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/:id(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_codeharbor_links_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_codeharbor_links_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/:id(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/:id(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_webauthn_credentials_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_user_webauthn_credentials_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /external_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/feedbacks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/feedbacks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_template_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /file_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /file_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_templates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /file_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /file_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_type_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /file_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /file_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_types_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /file_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /forgot_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forgot_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /forgot_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forgot_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/implement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implement_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"implement"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/implement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implement_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"implement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/import_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_confirm_exercises_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"import_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/import_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_confirm_exercises_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"import_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercises/import_start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_start_exercises_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"import_start"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/import_start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_start_exercises_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"import_start"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /import_task(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_task_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"import_task"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /import_task(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"import_task"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /import_uuid_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_uuid_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"import_uuid_check"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /import_uuid_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_uuid_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"import_uuid_check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insights_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/:id(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/:id(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_codeharbor_links_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_codeharbor_links_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/:id(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/:id(.:format)
 * @param {any} internal_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_webauthn_credentials_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_user_webauthn_credentials_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /internal_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/intervention(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const intervention_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"intervention"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/intervention(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const intervention_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"intervention"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/list_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_files_in_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"list_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/list_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_files_in_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"list_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/launch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_launch_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lti/launch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_launch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lti/return(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_return_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"return"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lti/return(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_return_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"return"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/:id/mark_as_solved(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_solved_request_for_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_solved"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/:id/mark_as_solved(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_solved_request_for_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_solved"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my_request_for_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_request_for_comments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my_request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /my_request_for_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_request_for_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my_request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /my_rfc_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_rfc_activity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my_rfc_activity"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /my_rfc_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_rfc_activity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my_rfc_activity"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_comment_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_comment_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /consumers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_consumer_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /consumers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_consumer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /error_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_error_template_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /error_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_error_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /error_template_attributes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_error_template_attribute_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /error_template_attributes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_error_template_attribute_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error_template_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_execution_environment_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_execution_environment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercises/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercise_collections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_collection_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /exercise_collections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_collection_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/new(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_programming_group_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/programming_groups/new(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_programming_group_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/new(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_user_exercise_feedback_url = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:exercise_id/feedbacks/new(.:format)
 * @param {any} exercise_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exercise_user_exercise_feedback_path = /*#__PURE__*/ __jsr.r({"exercise_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"exercise_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/new(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_external_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/codeharbor_links/new(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_external_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/new(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_external_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/webauthn_credentials/new(.:format)
 * @param {any} external_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_external_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /file_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_file_template_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /file_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_file_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /file_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_file_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /file_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_file_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/new(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_codeharbor_link_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/codeharbor_links/new(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_codeharbor_link_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"codeharbor_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/new(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_webauthn_credential_url = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:internal_user_id/webauthn_credentials/new(.:format)
 * @param {any} internal_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_internal_user_webauthn_credential_path = /*#__PURE__*/ __jsr.r({"internal_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"internal_user_id"],[2,[7,"/"],[2,[6,"webauthn_credentials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_proxy_exercise_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_proxy_exercise_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_request_for_comment_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_request_for_comment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sessions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tag_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tag_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tips/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tip_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tips/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webauthn_credential_authentication/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webauthn_credential_authentication_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webauthn_credential_authentication"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /webauthn_credential_authentication/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webauthn_credential_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webauthn_credential_authentication"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_index_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_index_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /programming_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_group_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_groups_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /programming_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /uploads/files/:id/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protected_upload_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /uploads/files/:id/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protected_upload_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxy_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxy_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxy_exercises_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxy_exercises_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manifest(.:file_extension)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_url = /*#__PURE__*/ __jsr.r({"file_extension":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"file_extension"]]]]], true);

/**
 * Generates rails route to
 * /manifest(.:file_extension)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_path = /*#__PURE__*/ __jsr.r({"file_extension":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"file_extension"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_service_worker_url = /*#__PURE__*/ __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_service_worker_path = /*#__PURE__*/ __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails_admin
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"rails_admin"]], true);

/**
 * Generates rails route to
 * /rails_admin
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"rails_admin"]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/bulk_action(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_bulk_action_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/bulk_action(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_bulk_action_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"bulk_action"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/bulk_delete(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_bulk_delete_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/bulk_delete(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_bulk_delete_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"bulk_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_dashboard_url = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]], true);

/**
 * Generates rails route to
 * /rails_admin/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_dashboard_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/delete(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_delete_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/delete(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_delete_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/edit(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_edit_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/edit(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_edit_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/export(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_export_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/export(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_export_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_index_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_index_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/new(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_new_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/new(.:format)
 * @param {any} model_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_new_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_show_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_show_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/show_in_app(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_show_in_app_url = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_in_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails_admin/:model_name/:id/show_in_app(.:format)
 * @param {any} model_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_admin_show_in_app_path = /*#__PURE__*/ __jsr.r({"model_name":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"rails_admin"]],[7,"/"]],[2,[3,"model_name"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_in_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/reload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reload_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/reload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reload_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_exercises/:id/reload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reload_proxy_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /proxy_exercises/:id/reload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reload_proxy_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proxy_exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/render_files/:id/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_protected_upload_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"render_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /uploads/render_files/:id/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_protected_upload_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"render_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/render/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/render/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /comments/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comments/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_request_for_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_request_for_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_for_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_for_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_for_comments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_for_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"request_for_comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal_users/:id/reset_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_internal_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal_users/:id/reset_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_internal_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_url = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /submissions/:id/run/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/run/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/score(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const score_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"score"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/score(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const score_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"score"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /study_groups/:id/set_as_current(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_as_current_study_group_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_as_current"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /study_groups/:id/set_as_current(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_as_current_study_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_as_current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /request_for_comments/:id/set_thank_you_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_thank_you_note_request_for_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_thank_you_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /request_for_comments/:id/set_thank_you_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_thank_you_note_request_for_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"request_for_comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_thank_you_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/shell(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shell_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shell"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/shell(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shell_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shell"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_in_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_out_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_out_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exercise_collections/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_exercise_collection_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercise_collections/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_exercise_collection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercise_collections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_external_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_external_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:external_user_id/exercises/:id/statistics(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_external_user_exercise_url = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:external_user_id/exercises/:id/statistics(.:format)
 * @param {any} external_user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_external_user_exercise_path = /*#__PURE__*/ __jsr.r({"external_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"external_user_id"],[2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /statistics/graphs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /statistics/graphs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /statistics/graphs/rfc-activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_rfc_activity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"rfc-activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /statistics/graphs/rfc-activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_rfc_activity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"rfc-activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /statistics/graphs/rfc-activity-history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_rfc_activity_history_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"rfc-activity-history"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /statistics/graphs/rfc-activity-history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_rfc_activity_history_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"rfc-activity-history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /statistics/graphs/user-activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_user_activity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"user-activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /statistics/graphs/user-activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_user_activity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"user-activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /statistics/graphs/user-activity-history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_user_activity_history_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"user-activity-history"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /statistics/graphs/user-activity-history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_graphs_user_activity_history_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"graphs"],[2,[7,"/"],[2,[6,"user-activity-history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /study_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const study_group_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /study_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const study_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /study_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const study_groups_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /study_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const study_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"study_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /submissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /submissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submissions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /submissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /execution_environments/sync_all_to_runner_management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_all_to_runner_management_execution_environments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[6,"sync_all_to_runner_management"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/sync_all_to_runner_management(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_all_to_runner_management_execution_environments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[6,"sync_all_to_runner_management"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /execution_environments/:id/sync_to_runner_management(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_to_runner_management_execution_environment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_to_runner_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /execution_environments/:id/sync_to_runner_management(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_to_runner_management_execution_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"execution_environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_to_runner_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_users/:id/tag_statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_statistics_external_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tag_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /external_users/:id/tag_statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_statistics_external_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tag_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /submissions/:id/test/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_submission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/:id/test/*filename
 * @param {any} id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]);

/**
 * Generates rails route to
 * /submissions/testrun_ai_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testrun_ai_feedback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"testrun_ai_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /submissions/testrun_ai_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testrun_ai_feedback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"testrun_ai_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tip_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tips_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tips"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tips_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tips"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webauthn_credential_authentication(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webauthn_credential_authentication_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webauthn_credential_authentication"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /webauthn_credential_authentication(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webauthn_credential_authentication_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webauthn_credential_authentication"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exercises/:id/working_times(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const working_times_exercise_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"working_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /exercises/:id/working_times(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const working_times_exercise_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"exercises"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"working_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

